import { apiFetch } from "@/integrations/backend/client";

export interface Note {
  id: string;
  client_user_id: string;
  creator_user_id: string;
  creator_name: string;
  creator_avatar_url: string | null;
  is_private_note_for_trainer_only: boolean;
  text: string;
  created_at: string | null;
}

export interface CreateNoteInput {
  client_user_id: string;
  text: string;
  is_private_note_for_trainer_only?: boolean;
}

export interface UpdateNoteInput {
  text?: string;
  is_private_note_for_trainer_only?: boolean;
}

/**
 * List notes for a client user.
 * @param clientUserId - UUID of the client user
 * @returns Array of notes
 */
export async function listNotes(clientUserId: string): Promise<Note[]> {
  const res = await apiFetch(`/api/v1/notes?client_user_id=${encodeURIComponent(clientUserId)}`, {
    method: "GET",
  });
  if (!res.ok) {
    throw new Error(`list_notes_failed:${res.status}`);
  }
  return (await res.json()) as Note[];
}

/**
 * Create a new note for a client user.
 * @param input - Note creation data
 * @returns Created note
 */
export async function createNote(input: CreateNoteInput): Promise<Note> {
  const res = await apiFetch("/api/v1/notes", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(input),
  });
  if (!res.ok) {
    throw new Error(`create_note_failed:${res.status}`);
  }
  return (await res.json()) as Note;
}

/**
 * Update an existing note.
 */
export async function updateNote(noteId: string, input: UpdateNoteInput): Promise<Note> {
  const res = await apiFetch(`/api/v1/notes/${encodeURIComponent(noteId)}`, {
    method: "PATCH",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(input),
  });
  if (!res.ok) {
    throw new Error(`update_note_failed:${res.status}`);
  }
  return (await res.json()) as Note;
}

/**
 * Delete a note.
 */
export async function deleteNote(noteId: string): Promise<void> {
  const res = await apiFetch(`/api/v1/notes/${encodeURIComponent(noteId)}`, {
    method: "DELETE",
  });
  if (!res.ok) {
    throw new Error(`delete_note_failed:${res.status}`);
  }
}

